const AboutPartner = () => {
  return (
    <div className="px-4 py-8 font-lexend sm:px-8 md:px-12 lg:px-[8.5rem] lg:py-[6.5rem] flex flex-col items-center justify-center space-y-12">
      <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-black">
        Our Pioneer Partners
      </h1>

      <div className="flex flex-col gap-8 sm:flex-row sm:flex-wrap sm:justify-center items-center w-full max-w-5xl">
        <img src="" alt="Nigeria flag" className="h-20 w-auto" />
        <img src="" alt="Unilag flag" className="h-20 w-auto" />
        <img src="" alt="Medflyer flag" className="h-20 w-auto" />

        <div className="aspect-square h-40 flex items-center justify-center rounded-full bg-[#00B680] text-center px-4">
          <p className="text-base sm:text-lg md:text-xl font-black text-white text-wrap text-center">
            CORNELL HEALTH LTD, LAGOS
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPartner;
